// extracted by mini-css-extract-plugin
module.exports = {"icon":"_2qmE9enLpH_XUMxRLnJ0h2"};